// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.TqphgXUyZh9jI8 {
  width: 100%;
  margin-bottom: var(--ds-space-200, 16px);
  padding: var(--ds-space-0, 0);
  border-spacing: 0;
  border-collapse: collapse;
}
table.TqphgXUyZh9jI8,
table.TqphgXUyZh9jI8 td {
  border: none;
  vertical-align: top;
}
table.TqphgXUyZh9jI8 tbody {
  background-color: transparent;
}
table.TqphgXUyZh9jI8 tbody td {
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-200, 15px) var(--ds-space-0, 0);
}
table.TqphgXUyZh9jI8 td:nth-child(2) {
  width: 200px;
  text-align: right;
}
table.TqphgXUyZh9jI8 tfoot {
  border-top: 1px solid var(--ds-border, #091e4224);
  font-size: 14px;
}
table.TqphgXUyZh9jI8 tfoot td {
  padding: var(--ds-space-150, 10px) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.J2pT7j8E1t6qkW {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.fNEWEsa9HUMirg {
  text-decoration: line-through;
}
.wT3nRlpSMvdmOb {
  color: var(--ds-text-success, #216e4e);
}
.Vu_EQLQkfbFpLv {
  font-size: 12px;
}
.RXpcomYfyU6GA6 {
  white-space: nowrap;
}
.J3y9pxYrp36RZ9 {
  color: var(--ds-text-danger, #ae2a19);
  font-weight: var(--ds-font-weight-bold, 700);
}
.H6coCvnDLpTaIT {
  font-weight: var(--ds-font-weight-semibold, 600);
}
.ksjohxSM_xf4CT {
  font-size: 11px;
  text-align: right;
}
.qtsaMG3L_n_NN7 {
  font-size: 14px;
}
.qtsaMG3L_n_NN7 .RMAj6q8OUgEYj3 {
  font-weight: var(--ds-font-weight-semibold, 600);
}
.qtsaMG3L_n_NN7 .H87ymHF6KY3Med {
  display: inline-block;
  width: 100px;
  color: var(--ds-text-information, #0055cc);
  font-size: 12px;
}
.qtsaMG3L_n_NN7 .J2pT7j8E1t6qkW {
  margin-top: var(--ds-space-200, 15px);
}
.qtsaMG3L_n_NN7 .J2pT7j8E1t6qkW li {
  margin-left: var(--ds-space-200, 16px);
  list-style-type: disc;
  font-size: 12px;
}
`, ""]);
// Exports
export var summary = `TqphgXUyZh9jI8`;
export var multiBoardGuestLineItem = `J2pT7j8E1t6qkW`;
export var strikeThrough = `fNEWEsa9HUMirg`;
export var discountedPrice = `wT3nRlpSMvdmOb`;
export var discountApplied = `Vu_EQLQkfbFpLv`;
export var pendingInvitationPrice = `RXpcomYfyU6GA6`;
export var errorMessage = `J3y9pxYrp36RZ9`;
export var salesTax = `H6coCvnDLpTaIT`;
export var nextBillDate = `ksjohxSM_xf4CT`;
export var nuskuSummaryTable = `qtsaMG3L_n_NN7`;
export var nuskuLicenseDescription = `RMAj6q8OUgEYj3`;
export var nuskuSavePercentage = `H87ymHF6KY3Med`;
export default ___CSS_LOADER_EXPORT___;
